import { siteInfo } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section id="cta-section" className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20flat%20lay%20of%20assorted%20fashion%20items%20including%20textured%20fabrics%20leather%20accessories%20and%20minimal%20jewelry%20on%20light%20oak%20wood%20surface%2C%20soft%20bright%20natural%20daylight%2C%20warm%20honey%20and%20cream%20color%20palette%2C%20editorial%20product%20photography%2C%20horizontal%20panoramic%20composition%2C%20refined%20and%20airy%20aesthetic&width=1800&height=1000&seq=cta-bg-wide-v4&orientation=landscape"
        alt="Hipobuy Spreadsheet Hub product showcase"
        title="Hipobuy Spreadsheet Hub - Start Exploring"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/30 to-black/45"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight max-w-lg mb-4 lowercase">
            hipobuy spreadsheet hub
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-md mb-8 leading-relaxed">
            Discover curated products across 14 categories. Redirect to our main store for instant shopping.
          </p>
          <a
            href={siteInfo.mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-3.5 bg-background-50 rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-background-100 group"
          >
            <span className="text-sm font-semibold text-foreground-900">buy it now</span>
            <span className="w-7 h-7 rounded-full bg-foreground-900 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
              <i className="ri-arrow-right-line text-sm text-background-50"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}